module.exports = __webpack_public_path__ + "img/Estest_vertical_crop.b912929c.png";